import React from 'react';
import {createRoot} from 'react-dom/client';
import DownloadApp from './components/DownloadApp.jsx';
import DownloadStore from './stores/DownloadStore';
import {DownloadProvider} from './stores/DownloadContext';
import {i18n, TranslationProvider} from './utils/I18n';

const downloadsContainer = document.getElementById('slx-downgridContainer');
if (downloadsContainer) {
	const data = JSON.parse(downloadsContainer.dataset.gridData);
	const store = new DownloadStore(data);
	const t = i18n(data.translations);
	const root = createRoot(downloadsContainer);
	root.render(
		<DownloadProvider value={store}>
			<TranslationProvider value={t}>
				<DownloadApp/>
			</TranslationProvider>
		</DownloadProvider>);
}
